import types from 'constants/actionTypes';
import { combineReducers } from 'redux';
import mergeByIds from '../../utils/mergeByIds';

const initialState = {
  byId: {},
};

const byId = (state, { type, payload }) => {
  if (typeof state === 'undefined') {
    return initialState.byId;
  }

  switch (type) {
    case types.GET_ADDITIONAL_CART_REQUEST_SUCCESS:
    case types.GET_CART_REQUEST_SUCCESS:
      return mergeByIds({
        byIdCurrent: state,
        byIdToMerge: payload.entities.functionalGroups,
      });
    default:
      return state;
  }
};

export default combineReducers({
  byId,
});
